import React, { useState } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import InputAdornment from '@material-ui/core/InputAdornment';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Tooltip from '@material-ui/core/Tooltip';

import checkIsMobile from 'utils/CheckIsMobile';

const useStyles = makeStyles((theme: Theme) => ({
	tooltip: {
		//maxWidth: 120,
		//whiteSpace: 'nowrap',
		color: 'white',
		backgroundColor: '#004E9C',
		marginTop: 24,
		fontSize:14,
		borderRadius:8,
		//TODO ver tamanio de tooltip WIP
	},
	arrow: {
		color: '#004E9C',
	},
	iconTooltip: {
		cursor: 'pointer',
	},
}));

type InputTooltipProps = {
	error: boolean;
	title: string;
};

function InputTooltip({ error, title }: InputTooltipProps) {
	const classes = useStyles();

	const [open, setOpen] = useState(false);

	const handleTooltipClose = () => {
		setOpen(false);
	};

	const handleTooltipOpen = () => {
		setOpen(true);
	};

	const algunawea = () => {
		setOpen(false);
	};

	if (checkIsMobile()) {
		return (
			<ClickAwayListener onClickAway={algunawea}>
				<div>
					<Tooltip
						title={title}
						arrow
						classes={{
							tooltip: classes.tooltip,
							arrow: classes.arrow,
						}}
						PopperProps={{
							disablePortal: false,
						}}
						onClose={handleTooltipClose}
						open={open}
						disableFocusListener
						disableHoverListener
						disableTouchListener
					>
						<InputAdornment position="end">
							<HelpOutlineIcon
								onClick={handleTooltipOpen}
								color={error ? 'error' : 'secondary'}
								className={classes.iconTooltip}
							/>
						</InputAdornment>
					</Tooltip>
				</div>
			</ClickAwayListener>
		);
	} else {
		return (
			<Tooltip
				title={title}
				arrow
				classes={{
					tooltip: classes.tooltip,
					arrow: classes.arrow,
				}}
			>
				<InputAdornment position="end">
					<HelpOutlineIcon color={error ? 'error' : 'secondary'} className={classes.iconTooltip} />
				</InputAdornment>
			</Tooltip>
		);
	}
}
export default InputTooltip;
